// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'f03886a6-05c5-4060-8818-91d200dfe213',
      type: 'Container',
      name: 'tileSpriteSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'fd2176d6-8171-4688-86fc-8ce267ca1310',
      type: 'Container',
      name: 'coinContainerSlot',
      className: '',
      x: 14,
      y: 21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '91719474-6843-4a89-9fdf-a3ec1b18967c',
      type: 'Container',
      name: 'livesContainerSlot',
      className: '',
      x: 243,
      y: 21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b148ea13-f298-4b2d-8aca-bcb60320b451',
      type: 'Container',
      name: 'tasksContainer',
      className: '',
      x: 302,
      y: 21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '05019ec1-e70d-4f58-bc9f-9fd1bd7a46f3',
      type: 'Container',
      name: 'soundSlot',
      className: '',
      x: 622,
      y: 63,
      scale: {
        x: 1.45,
        y: 1.45
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          x: {
            value: 'RIGHT - 93'
          }
        }
      }
    },
    {
      id: '49f6663f-1551-4008-9b9f-e2be48bb9d45',
      type: 'Sprite',
      name: 'settingsButton',
      className: '',
      x: 600,
      y: 62,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'settings',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        tapSound: 'UI_Button_Click',
        dynamicValues: {
          x: {
            value: 'RIGHT - 53'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class TopBarLayout {
  static raw = raw;
  root!: Container;
  tileSpriteSlot!: Container;
  coinContainerSlot!: Container;
  livesContainerSlot!: Container;
  tasksContainer!: Container;
  soundSlot!: Container & { data: typeof raw['list'][5]['data'] };
  settingsButton!: Sprite & { data: typeof raw['list'][6]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
